/**
 * Gepinnte Produkte auf der Kollektionsseite.
 *
 * Eine Anzeige zeigt bestimmte Teile und verlinkt auf eine Kategorie.
 * Damit diese Teile dort oben stehen, nimmt die URL sie mit:
 *
 *   /collections/new-in?pin=handle-a,handle-b,handle-c
 *
 * Shopify-Liquid kann beliebige URL-Parameter nicht lesen, deshalb
 * passiert das hier im Browser. Der serverseitige Weg ueber das
 * Collection-Metafeld custom.pin_produkte bleibt davon unberuehrt und
 * wird von einem Parameter in der URL ueberstimmt.
 *
 * Die Karten kommen aus dem Theme (templates/product.pin-card.liquid),
 * nicht aus JavaScript. So gibt es nur ein Karten-Markup.
 *
 * Sobald der Nutzer selbst filtert, loesen sich die Pins auf: er hat
 * dann eine eigene Absicht, und ein gepinntes Teil muss dem Filter
 * nicht einmal entsprechen. Nimmt er den Filter wieder weg, stehen sie
 * wieder oben, weil der Parameter in der URL bleibt.
 *
 * Nach jedem Filterwechsel rendert das Theme das Grid neu und feuert
 * "collection:reloaded". Die Pins werden dann erneut gesetzt. Die
 * Handles liegen im Modulspeicher, damit das auch dann noch geht, wenn
 * der Parameter aus der URL verschwunden ist.
 */
(function () {
  'use strict';

  var PARAM = 'pin';
  var MAX = 5;
  var GRID = '#CollectionAjaxContent .grid--uniform';
  var KARTE = '.lp-pin-card';

  var speicher = {};
  var handles = ausUrlLesen();

  if (!handles.length) return;

  function ausUrlLesen() {
    var roh;
    try {
      roh = new URLSearchParams(window.location.search).get(PARAM);
    } catch (e) {
      return [];
    }
    if (!roh) return [];

    var gesehen = {};
    return roh
      .split(',')
      .map(function (h) {
        return String(h).trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
      })
      .filter(function (h) {
        if (!h || gesehen[h]) return false;
        gesehen[h] = true;
        return true;
      })
      .slice(0, MAX);
  }

  function filterAktiv() {
    try {
      var gefunden = false;
      new URLSearchParams(window.location.search).forEach(function (wert, schluessel) {
        if (schluessel.indexOf('filter.') === 0) gefunden = true;
      });
      return gefunden;
    } catch (e) {
      return false;
    }
  }

  function pinsEntfernen(grid) {
    Array.prototype.slice.call(grid.querySelectorAll(KARTE)).forEach(function (alt) {
      alt.parentNode.removeChild(alt);
    });
  }

  /* Eine Karte holen. Fehlschlaege sind still: ein Tippfehler im
     Handle darf die Seite nicht stoeren, das Grid bleibt dann
     einfach wie es ist. */
  function karteHolen(handle) {
    if (speicher[handle]) return Promise.resolve(speicher[handle]);

    return fetch('/products/' + encodeURIComponent(handle) + '?view=pin-card', {
      credentials: 'same-origin'
    })
      .then(function (antwort) {
        if (!antwort.ok) return null;
        return antwort.text();
      })
      .then(function (html) {
        if (!html) return null;
        var hilfs = document.createElement('div');
        hilfs.innerHTML = html.trim();
        var karte = hilfs.querySelector('[data-product-handle]');
        if (karte) speicher[handle] = karte.outerHTML;
        return speicher[handle] || null;
      })
      .catch(function () {
        return null;
      });
  }

  /* Die Breite der Karte richtet sich nach dem Grid, in das sie
     einsortiert wird: 4er-Grid und 5er-Grid haben verschiedene
     Klassen. Deshalb werden sie von einer vorhandenen Karte
     uebernommen statt fest verdrahtet. */
  function breiteAngleichen(karte, vorbild) {
    if (!vorbild) return;

    Array.prototype.slice.call(karte.classList).forEach(function (klasse) {
      if (klasse.indexOf('small--') === 0 || klasse.indexOf('medium-up--') === 0) {
        karte.classList.remove(klasse);
      }
    });

    Array.prototype.slice.call(vorbild.classList).forEach(function (klasse) {
      if (klasse.indexOf('small--') === 0 || klasse.indexOf('medium-up--') === 0) {
        karte.classList.add(klasse);
      }
    });

    var aos = vorbild.getAttribute('data-aos');
    if (aos) karte.setAttribute('data-aos', aos);
  }

  function anwenden() {
    var grid = document.querySelector(GRID);
    if (!grid) return;

    if (filterAktiv()) {
      pinsEntfernen(grid);
      return;
    }

    Promise.all(handles.map(karteHolen)).then(function (ergebnisse) {
      /* Das Grid erst nach dem Laden greifen: waehrend der Abfrage kann
         ein Filterwechsel es ausgetauscht haben. */
      var aktuellesGrid = document.querySelector(GRID);
      if (!aktuellesGrid) return;

      /* Alte Pins entfernen, bevor neue kommen. Nach einem
         Filterwechsel ist das Grid frisch vom Server, dann ist hier
         nichts zu tun. */
      pinsEntfernen(aktuellesGrid);

      var referenz = aktuellesGrid.querySelector('.grid__item:not(' + KARTE + ')');
      var vorher = null;

      handles.forEach(function (handle, i) {
        var html = ergebnisse[i];
        if (!html) return;

        var hilfs = document.createElement('div');
        hilfs.innerHTML = html;
        var karte = hilfs.firstElementChild;
        if (!karte) return;

        karte.classList.add('lp-pin-card');
        breiteAngleichen(karte, referenz);

        /* Dieselbe Karte weiter unten im Grid entfernen, sonst steht
           das Produkt zweimal auf der Seite. */
        var dublette = aktuellesGrid.querySelector(
          '.grid__item[data-product-handle="' + handle + '"]'
        );
        if (dublette && !dublette.classList.contains('lp-pin-card')) {
          dublette.parentNode.removeChild(dublette);
        }

        if (vorher) {
          vorher.insertAdjacentElement('afterend', karte);
        } else {
          aktuellesGrid.insertBefore(karte, aktuellesGrid.firstChild);
        }
        vorher = karte;
      });

      /* Quick-Shop, Farbfelder und Bild-Nachladen an den neuen Karten
         verkabeln. Die Funktion gehoert dem Theme und wird nach jedem
         eigenen Rendern aufgerufen. */
      if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
        try {
          window.theme.reinitProductGridItem();
        } catch (e) {
          /* Das Theme hat sich beschwert, die Karten stehen trotzdem. */
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anwenden);
  } else {
    anwenden();
  }

  document.addEventListener('collection:reloaded', anwenden);
})();
